import moment from 'moment';
import Constants from '../utils/constants';
import BaseServiceCrud from './BaseServiceCrud';

export default class UserVoucherService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'user-voucher';
    
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            locale: criteria.locale,
            first_result: criteria.firstResult,
            date_from: criteria.dateFrom ? moment(criteria.dateFrom).format(Constants.DATE_GET_REQUEST_FORMAT) : undefined,
            date_to: criteria.dateTo ? moment(criteria.dateTo).format(Constants.DATE_GET_REQUEST_FORMAT) : undefined,
            max_results: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
            user: criteria.user,
            voucher : criteria.voucher,
            voucher_code: criteria.voucherCode,
        });
    }

    archive(id) {
        return this.fetch(`${this.domain}/${this.path}/archive/${id}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    refund(id) {
        return this.fetch(`${this.domain}/${this.path}/refund/${id}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
   
}
